export function setRepeatData(repeatData){
    return {
        type: 'SET_REPEAT_DATA',
        repeatData
    }
}

export function billPayCart(billPayForm){
    return {
        type: 'BILL_PAY_CART',
        billPayForm
    }
}

export function billPay(billPayPayload){
    return {
        type: 'BILL_PAY_PAYLOAD',
        billPayPayload
    }
}
